var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAds1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ads_6206841 1",
    clipPath: "url(#clip0_1461_14132)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.1016 40.8945V9.74219C55.1016 6.93134 52.8148 4.64453 50.0039 4.64453H8.99609C6.18525 4.64453 3.89844 6.93134 3.89844 9.74219V40.8945H55.1016Z",
    fill: "url(#paint0_linear_1461_14132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.6195 22.1703L18.4044 11.0012L18.3861 10.9546C18.0832 10.2183 17.3734 9.74283 16.5772 9.74283C16.5765 9.74283 16.5756 9.74283 16.5749 9.74283C15.7779 9.74373 15.0682 10.221 14.7666 10.9587L10.498 22.1654C10.1639 23.0424 10.6041 24.0241 11.481 24.358C12.3581 24.6921 13.3398 24.2519 13.6737 23.375L14.3163 21.6878H18.8049L19.4398 23.3702C19.7712 24.2482 20.7515 24.6913 21.6296 24.3601H21.6297C22.5077 24.0287 22.9509 23.0484 22.6195 22.1703ZM15.6107 18.2894L16.571 15.7681L17.5224 18.2894H15.6107ZM26.7167 24.4695C26.2683 24.4695 25.838 24.2923 25.5196 23.9763C25.1997 23.6587 25.0192 23.2271 25.0175 22.7764C25.0173 22.7353 25.0027 18.6521 25.0027 17.0936C25.0027 15.8024 24.9946 11.4456 24.9946 11.4453C24.9938 10.9941 25.1724 10.5611 25.4911 10.2417C25.8099 9.92238 26.2426 9.74294 26.6938 9.74294H29.9021C31.8541 9.74294 33.5513 10.5752 34.6809 12.0863C35.6591 13.3947 36.176 15.1306 36.176 17.1061C36.176 21.2958 33.5895 24.3819 30.0257 24.4441C29.1097 24.4602 26.8202 24.4691 26.7233 24.4694C26.721 24.4695 26.7188 24.4695 26.7167 24.4695ZM28.396 13.1414C28.3983 14.513 28.4011 16.3336 28.4011 17.0936C28.4011 17.9939 28.4059 19.7431 28.4101 21.0619C28.9994 21.0579 29.6027 21.0526 29.9663 21.0463C31.9082 21.0123 32.7773 19.0429 32.7773 17.1061C32.7773 16.1761 32.57 13.1413 29.9019 13.1413L28.396 13.1414ZM43.513 24.4695C41.4961 24.4695 39.6017 23.6554 38.3152 22.2359C37.6851 21.5405 37.7379 20.4659 38.4332 19.8357C39.129 19.2054 40.2034 19.2585 40.8335 19.9538C41.4674 20.6533 42.469 21.071 43.5129 21.071C44.5397 21.071 45.1299 20.445 45.2054 20.0219C45.2968 19.5096 44.5943 19.056 43.9063 18.8022C42.1446 18.1523 40.5797 17.4558 40.514 17.4265C40.4321 17.3899 40.3532 17.3469 40.2781 17.298C38.9919 16.4595 38.3294 14.9893 38.5487 13.4613C38.7815 11.84 39.9623 10.5207 41.6306 10.0181C44.7066 9.09146 47.4377 10.7039 48.0388 11.8282C48.4813 12.6559 48.1692 13.6855 47.3417 14.1279C46.6078 14.5204 45.7152 14.3194 45.2138 13.6918C45.0145 13.5443 43.9838 12.8586 42.6107 13.2721C42.0432 13.4432 41.9334 13.7991 41.9126 13.9442C41.8969 14.0533 41.8991 14.2453 42.0602 14.3939C42.4948 14.5836 43.7442 15.1201 45.0825 15.6136C48.1 16.7267 48.8526 18.9291 48.5508 20.6191C48.1528 22.8503 46.034 24.4695 43.513 24.4695ZM47.0586 33.532C47.0586 34.4704 46.2978 35.2312 45.3594 35.2312H19.8711V35.7976C19.8711 36.7361 19.1103 37.4968 18.1719 37.4968C17.2335 37.4968 16.4727 36.7361 16.4727 35.7976V35.2312H13.6406C12.7022 35.2312 11.9414 34.4704 11.9414 33.532C11.9414 32.5936 12.7022 31.8328 13.6406 31.8328H16.4727V31.2664C16.4727 30.328 17.2335 29.5672 18.1719 29.5672C19.1103 29.5672 19.8711 30.328 19.8711 31.2664V31.8328H45.3594C46.2978 31.8328 47.0586 32.5936 47.0586 33.532ZM47.7383 53.3562H11.2617C5.32771 53.3562 0.5 48.5285 0.5 42.5945C0.5 41.6561 1.2608 40.8953 2.19922 40.8953H56.8008C57.7392 40.8953 58.5 41.6561 58.5 42.5945C58.5 48.5285 53.6723 53.3562 47.7383 53.3562Z",
    fill: "url(#paint1_linear_1461_14132)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1461_14132",
    x1: 29.5,
    y1: 40.8945,
    x2: 29.5,
    y2: 4.64453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1461_14132",
    x1: 29.5,
    y1: 53.3562,
    x2: 29.5,
    y2: 9.74249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1461_14132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAds1);
export default __webpack_public_path__ + "static/media/ads1.1cd973befd37c51486f636f82533d19c.svg";
export { ForwardRef as ReactComponent };